var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15px",
    height: "15px",
    viewBox: "0 0 15 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "F9948F45-14E7-4556-AEBC-D1069C326E29@0.5x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Navic-GoSend---Phase-2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "5.5-Error---All-drivers-are-busy",
    transform: "translate(-340.000000, -44.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "navigation/24/ic_cancel",
    transform: "translate(335.000000, 40.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.75690678,5.14569322 L12.0498,10.4378 L17.3426932,5.14569322 C17.7332175,4.75516893 18.3663825,4.75516893 18.7569068,5.14569322 C19.1474311,5.53621751 19.1474311,6.16938249 18.7569068,6.55990678 L13.4648,11.8528 L18.7569068,17.1456932 C19.1474311,17.5362175 19.1474311,18.1693825 18.7569068,18.5599068 C18.3663825,18.9504311 17.7332175,18.9504311 17.3426932,18.5599068 L12.0498,13.2678 L6.75690678,18.5599068 C6.36638249,18.9504311 5.73321751,18.9504311 5.34269322,18.5599068 C4.95216893,18.1693825 4.95216893,17.5362175 5.34269322,17.1456932 L10.6348,11.8528 L5.34269322,6.55990678 C4.95216893,6.16938249 4.95216893,5.53621751 5.34269322,5.14569322 C5.73321751,4.75516893 6.36638249,4.75516893 6.75690678,5.14569322 Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancel);
export default __webpack_public_path__ + "static/media/cancel.497de076586ac991eb026a375c669bb0.svg";
export { ForwardRef as ReactComponent };